#### `ApplicationQuestionInput.questionHtml` limit increased

The maximum size of the [`ApplicationQuestionInput.questionHtml`] field has been increased to 1,000 bytes in UTF-8 encoding.

We’ve modified this limit to support compliance questions that are non-trivial to reword due to legal implications;
we still discourage long questions in the general case as they negatively impact the candidate experience.
Note that the increase does not apply to the [`ApplicationPrivacyConsentInput.descriptionHtml`] field.

See our [questionnaire limits] for more information.

[`applicationquestioninput.questionhtml`]: /schema/named-type/ApplicationQuestionInput#/field/questionHtml
[`applicationprivacyconsentinput.descriptionhtml`]: /schema/named-type/ApplicationPrivacyConsentInput#/field/descriptionHtml
[questionnaire limits]: /use-cases/job-posting/questionnaires#limits
